import { render, staticRenderFns } from "./ChoralConductingAcademy.vue?vue&type=template&id=2e502547&scoped=true&"
import script from "./ChoralConductingAcademy.vue?vue&type=script&lang=ts&"
export * from "./ChoralConductingAcademy.vue?vue&type=script&lang=ts&"
import style0 from "./ChoralConductingAcademy.vue?vue&type=style&index=0&id=2e502547&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e502547",
  null
  
)

export default component.exports